import * as React from 'react';

import { withTranslation } from '@i18n';

// import type { Props } from './types';
import {
  StyledCover,
  StyledCard,
  StyledHeadingTab,
  StyledCardContent,
  StyledCoverMaxWidthWrapper,
  StyledSecondOpinionIcon,
  StyledTreatmentAbroad,
  StyledPMT,
  StyledHeading,
  StyledCollapsseIcon,
  StyledExpandIcon,
  StyledImage,
  StyledText,
  StyledContent,
  StyledMainHeading
} from './styles';


const Products = ({ t }) => {
  const [hover, setHover] = React.useState(0);
  const handleClick = (count) => {
    if (count === hover) {
      setHover(-1);
    } else {
      setHover(count);
    }
  };
  return (
    <StyledCover>
      <StyledMainHeading>
        {t('Products.ProductsHeading')}
      </StyledMainHeading>
      <StyledCoverMaxWidthWrapper>
        <StyledCard>
          <StyledHeadingTab onClick={() => handleClick(0)}>
            <StyledHeading>
              <StyledSecondOpinionIcon />
              <StyledText>
                {t('Products.SecondOpinion')}
              </StyledText>
            </StyledHeading>
            {hover === 0 ? <StyledCollapsseIcon /> : <StyledExpandIcon /> }
          </StyledHeadingTab>
          <StyledCardContent hover={hover === 0}>
            <StyledContent>
              {t('Products.SecondOpinionContent')}
            </StyledContent>
            <StyledImage src="../../../static/images/HowItWorks/SecondOpinion.webp" alt="" />
          </StyledCardContent>
        </StyledCard>
        <StyledCard>
          <StyledHeadingTab onClick={() => handleClick(1)}>
            <StyledHeading>
              <StyledTreatmentAbroad />
              <StyledText>
                {t('Products.TreatmentAbroad')}
              </StyledText>
            </StyledHeading>
            {hover === 1 ? <StyledCollapsseIcon /> : <StyledExpandIcon /> }
          </StyledHeadingTab>

          <StyledCardContent hover={hover === 1}>
            <StyledContent>
              {t('Products.TreatmentAbroadContent')}
            </StyledContent>
            <StyledImage src="../../../static/images/HowItWorks/TreatmentAbroad.webp" alt="" />
          </StyledCardContent>
        </StyledCard>
        <StyledCard>
          <StyledHeadingTab onClick={() => handleClick(2)}>
            <StyledHeading>
              <StyledPMT />
              <StyledText>
                {t('Products.PMT')}
              </StyledText>
            </StyledHeading>
            {hover === 2 ? <StyledCollapsseIcon /> : <StyledExpandIcon /> }
          </StyledHeadingTab>

          <StyledCardContent hover={hover === 2}>
            <StyledContent>
              {t('Products.PMTContent')}
            </StyledContent>
            <StyledImage pms src="../../../static/images/HowItWorks/PMS.webp" alt="" />
          </StyledCardContent>
        </StyledCard>
      </StyledCoverMaxWidthWrapper>
    </StyledCover>
  );
};

Products.getInitialProps = () => ({
  namespacesRequired: ['HowItWorksScreen']
});

export default withTranslation('HowItWorksScreen')(Products);
